import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

import './VideoPlayer.scss'

const VideoPlayer = ({ src }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        let hls;

        if (!video) return;

        const handlePlay = () => {
            if (video.paused) {
                video.play().catch(error => {
                    console.error("Error attempting to play:", error);
                });
            }
        };

        if (src.endsWith('.m3u8')) {
            if (Hls.isSupported()) {
                hls = new Hls();
                hls.loadSource(src);
                hls.attachMedia(video);
                hls.on(Hls.Events.MANIFEST_PARSED, handlePlay);
                hls.on(Hls.Events.ERROR, (event, data) => {
                    console.error("HLS error:", data);
                });
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = src;
                video.addEventListener('loadedmetadata', handlePlay);
            } else {
                console.error("HLS is not supported in this browser.");
            }
        } else {
            video.src = src;
            video.addEventListener('loadedmetadata', handlePlay);
        }

        return () => {
            if (hls) {
                hls.destroy();
            }
            video.removeEventListener('loadedmetadata', handlePlay);
        };
    }, [src]);

    return (
        <div className="video-player">
            <video className="video" ref={videoRef} controls />
        </div>
    );
};

export default VideoPlayer;
